import { all_routes } from "../../../feature-module/router/all_routes"
const routes = all_routes

const baseSidebarData = [
  /*  {
    label: "MAIN",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-dashboard",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Admin Dashboard", link: routes.adminDashboard },
          { label: "Teacher Dashboard", link: routes.teacherDashboard },
          { label: "Student Dashboard", link: routes.studentDashboard },
          { label: "Parent Dashboard", link: routes.parentDashboard },
        ],
      },
        {
        label: "Application",
        icon: "ti ti-layout-list",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Chat",
            link: routes.chat,
            showSubRoute: false,
          },
          {
            label: "Call",
            link: routes.audioCall,
            showSubRoute: false,
          },
          {
            label: "Calendar",
            link: routes.calendar,
            showSubRoute: false,
          },
          {
            label: "Email",
            link: routes.email,
            showSubRoute: false,
          },
          {
            label: "To Do",
            link: routes.todo,
            showSubRoute: false,
          },
          {
            label: "Notes",
            link: routes.notes,
            showSubRoute: false,
          },
          {
            label: "File Manager",
            link: routes.fileManager,
            showSubRoute: false,
          },
        ],
      },
    ],
  }, */
  {
    label: "MAIN",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Dashboard",
    submenuItems: [
      {
        label: "Dashboard",
        link: routes.adminDashboard,
        icon: "ti ti-layout-dashboard",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "dashboard.view",
        // NOT teacherAllowed: for role "teacher" this renders
        // mainMenu/teacherDashboard, a leftover template page with
        // hardcoded fake data (wrong name, fake syllabus %, fake schedule).
        // The real one is RMS -> Teacher Portal -> Teacher Dashboard
        // (teacher/teacher-dashboard), which stays visible on its own.
        // Flagged 2026-10-30.
        visible: true,
      },
    ],
  },

  /*
  @TODO: We will reopen it when introducing new features 
  */

  // {
  //   label: "LAYOUT",
  //   submenuOpen: false,
  //   showSubRoute: false,
  //   submenuHdr: "LAYOUT",
  //   submenuItems: [
  //     {
  //       label: "Default",
  //       icon: "ti ti-layout-sidebar",
  //       submenu: false,
  //       showSubRoute: false,
  //       link: routes.layoutDefault,
  //       themeSetting: true,
  //     },
  //     {
  //       label: "Mini",
  //       icon: "ti ti-layout-align-left",
  //       submenu: false,
  //       showSubRoute: false,
  //       link: routes.layoutMini,
  //       themeSetting: true,
  //     },
  //     {
  //       label: "RTL",
  //       icon: "ti ti-text-direction-rtl",
  //       submenu: false,
  //       showSubRoute: false,
  //       link: routes.layoutRtl,
  //       themeSetting: true,
  //     },
  //     {
  //       label: "Box",
  //       icon: "ti ti-layout-distribute-vertical",
  //       submenu: false,
  //       showSubRoute: false,
  //       link: routes.layoutBox,
  //       themeSetting: true,
  //     },
  //     {
  //       label: "Dark",
  //       icon: "ti ti-moon",
  //       submenu: false,
  //       showSubRoute: false,
  //       link: routes.layoutDark,
  //       themeSetting: true,
  //     },
  //   ],
  // },
  {
    label: "Admissions",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Admissions",
    submenuItems: [
      {
        label: "Registrations",
        icon: "ti ti-clipboard-text",
        submenu: true,
        showSubRoute: false,
        requiredPermission: "",
        submenuItems: [
          {
            label: "New Registration",
            link: routes.addRegistrationForm,
            requiredPermission: "registration.create",
            visible: true,
          },
          {
            label: "All Registrations",
            link: routes.registrationFormList,
            subLink1: routes.registrationFormDetail,
            subLink2: routes.registrationFormGrid,
            requiredPermission: "registration.view",
            visible: true,
          },
          {
            label: "Test Groups",
            link: routes.testGroup,
            requiredPermission: "test-group.view",
            visible: true,
          },
          {
            label: "Interview Lists",
            link: routes.interviewStatus,
            requiredPermission: "interview.view",
            visible: true,
          },
        ],
      },
      {
        label: "Admissions",
        icon: "ti ti-certificate",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "New Admission",
            link: routes.addAdmissionForm,
            requiredPermission: "admission.create",
            visible: true,
          },
          {
            label: "All Admissions",
            link: routes.admissionFormList,
            subLink1: routes.admissionFormDetail,
            subLink2: routes.admissionFormGrid,
            requiredPermission: "admission.view",
            visible: true,
          },
        ],
      },
    ],
  },
  {
    label: "People",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "People",

    submenuItems: [
      {
        label: "Students",
        icon: "ti ti-school",
        submenu: true,
        showSubRoute: false,
        requiredPermission: "",
        submenuItems: [
          // {
          //   label: "All Students",
          //   link: routes.studentGrid,
          //   subLink1: routes.addStudent,
          //   subLink2: routes.editStudent,
          // },
          {
            label: "Students List",
            link: routes.studentList,
            requiredPermission: "student.view",
            visible: true,
          },
          {
            label: "Student Status",
            link: routes.studentStatus,
            requiredPermission: "student-status.view",
            visible: true,
          },
          // {
          // label: "Students Details",
          // link: routes.studentDetail,
          // subLink1: routes.studentLibrary,
          // subLink2: routes.studentResult,
          // subLink3: routes.studentFees,
          // subLink4: routes.studentLeaves,
          // subLink5: routes.studentTimeTable,
          // },
          {
            label: "Student Promotion",
            link: routes.studentPromotion,
            requiredPermission: "student.view",
            visible: true,
          },
        ],
      },
      // {
      //   label: "Parents",
      //   icon: "ti ti-user-bolt",
      //   showSubRoute: false,
      //   submenu: true,
      //   submenuItems: [
      //     { label: "All Parents", link: routes.parentGrid },
      //     { label: "Parents List", link: routes.parentList },
      //   ],
      // },
      // {
      //   label: "Guardians",
      //   icon: "ti ti-user-shield",
      //   showSubRoute: false,
      //   submenu: true,
      //   submenuItems: [
      //     { label: "All Guardians", link: routes.guardiansGrid },
      //     { label: "Guardians List", link: routes.guardiansList },
      //   ],
      // },
      // {
      //   label: "Teachers",
      //   icon: "ti ti-users",
      //   submenu: true,
      //   showSubRoute: false,

      //   submenuItems: [
      //     {
      //       label: "All Teachers",
      //       link: routes.teacherGrid,
      //       subLink1: routes.addTeacher,
      //       subLink2: routes.editTeacher,
      //     },
      //     { label: "Teacher List", link: routes.teacherList },
      // {
      // label: "Teacher Details",
      // link: routes.teacherDetails,
      // subLink1: routes.teacherLibrary,
      // subLink2: routes.teacherSalary,
      // subLink3: routes.teacherLeaves,
      // },
      //     { label: "Routine", link: routes.teachersRoutine },
      //   ],
      // },
    ],
  },
  {
    label: "Academic",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Academic",

    submenuItems: [
      // Classes moved to the Settings group (see below).
      // {
      //   label: "Class Room",
      //   link: routes.classRoom,
      //   icon: "ti ti-building",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      // {
      //   label: "Class Routine",
      //   link: routes.classRoutine,
      //   icon: "ti ti-bell-school",
      //   showSubRoute: false,
      //   submenu: false,
      //   requiredPermission: "timetable.view",
      // },
      // {
      //   label: "Section",
      //   link: routes.classSection,
      //   icon: "ti ti-square-rotated-forbid-2",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      // Session moved to the Settings group.
      // Term moved into RMS → Configuration ("Exam Terms") -- kept in RMS only.
      // Duplicates of RMS → Operations / Configuration — kept in RMS only.
      /*
      {
        label: "Term",
        link: routes.term,
        icon: "ti ti-calendar-event",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "term.view",
        visible: true,
      },
      {
        label: "Result Breakdown",
        link: routes.resultBreakdown,
        icon: "ti ti-chart-bar",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "resultBreakdown.view",
        // visible: true,
      },
      {
        label: "Marks Entry",
        link: routes.marks,
        icon: "ti ti-edit",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "student-marks.view",
      },
      {
        label: "Marks Tabulation",
        link: routes.marksTabulation,
        icon: "ti ti-table",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "student-marks.view",
      },
      {
        label: "Grade Scales",
        link: routes.gradeConfig,
        icon: "ti ti-award",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "grade_configs.view",
      },
      {
        label: "Report Cards",
        link: routes.reportCard,
        icon: "ti ti-file-text",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "student-marks.view",
      },
      {
        label: "Report Card Designer",
        link: routes.reportCardDesigner,
        icon: "ti ti-layout-board",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "resultBreakdown.view",
      },
      {
        label: "Final Term Entry",
        link: routes.finalTermEntry,
        icon: "ti ti-calendar-check",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "student-marks.view",
      },
      {
        label: "Courses",
        link: routes.courses,
        icon: "ti ti-book",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "courses.view",
        visible: true,
      },
      */
      // Courses moved into RMS → Configuration -- kept in RMS only.

      // {
      //   label: "Syllabus",
      //   link: routes.classSyllabus,
      //   icon: "ti ti-book-upload",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      {
        label: "Class Routine",
        link: routes.classTimetable,
        icon: "ti ti-table",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "class-timetable.view",
        visible: true,
      },
      {
        label: "Class Assignments",
        link: routes.classHomeWork,
        icon: "ti ti-license",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "class-assignment.view",
        visible: true,
      },

      // {
      //   label: "Examinations",
      //   icon: "ti ti-hexagonal-prism-plus",
      //   submenu: true,
      //   showSubRoute: false,

      //   submenuItems: [
      //     { label: "Exam", link: routes.exam },
      //     { label: "Exam Schedule", link: routes.examSchedule },
      //     { label: "Grade", link: routes.grade },
      //     { label: "Exam Attendance", link: routes.examAttendance },
      //     { label: "Exam Results", link: routes.examResult },
      //   ],
      // },
      // {
      //   label: "Reasons",
      //   link: routes.AcademicReason,
      //   icon: "ti ti-lifebuoy",
      //   showSubRoute: false,
      //   submenu: false,
      // },
    ],
  },
    {
    label: "MANAGEMENT",
    submenuOpen: true,
    submenuHdr: "Management",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Fees Collection",
        icon: "ti ti-report-money",
        submenu: true,
        showSubRoute: false,
        requiredPermission: "",
        submenuItems: [
          // { label: "Fees Group", link: routes.feesGroup },
          {
            label: "Fees",
            link: routes.feesType,
            requiredPermission: "fee-type.view",
            visible: true,
          },
          {
            label: "Collect Fees",
            link: routes.collectFees,
            requiredPermission: "fees.view",
            visible: true,
          },
          // { label: "Fees Master", link: routes.feesMaster },
          // { label: "Fees Assign", link: routes.feesAssign },
          // { label: "Collect Fees", link: routes.collectFees },
        ],
      },

      {
        label: "Defaulters",
        icon: "ti ti-report-money",
        submenu: true,
        showSubRoute: false,
        requiredPermission: "",
        submenuItems: [
          {
            label: "Defaulters List",
            link: routes.defaultersList,
            requiredPermission: "fees.view",
            visible: true,
          },
        ],
      },

      {
        label: "Library",
        icon: "ti ti-notebook",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          {
            label: "Books",
            link: routes.libraryBooks,
            requiredPermission: "library-books.view",
            visible: true,
          },
          {
            label: "Issue Book",
            link: routes.libraryIssueBook,
            requiredPermission: "book-issue.view",
            visible: true,
          },
          // { label: "Return", link: routes.libraryReturn },
        ],
      },
      // {
      //   label: "Sports",
      //   link: routes.sportsList,
      //   icon: "ti ti-run",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      // {
      //   label: "Players",
      //   link: routes.playerList,
      //   icon: "ti ti-play-football",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      // {
      //   label: "Hostel",
      //   icon: "ti ti-building-fortress",
      //   submenu: true,
      //   showSubRoute: false,

      //   submenuItems: [
      //     { label: "Hostel List", link: routes.hostelList },
      //     { label: "Hostel Rooms", link: routes.hostelRoom },
      //     { label: "Room Type", link: routes.hostelType },
      //   ],
      // },
      {
        label: "Transport",
        icon: "ti ti-bus",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          {
            label: "Assign and Collect ",
            link: routes.transportAssignVehicle,
            requiredPermission: "transport.view",
            visible: true,
          },
          {
            label: "Transport Invoices",
            link: routes.transportInvoices,
            requiredPermission: "fees.view",
            visible: true,
          },
          {
            label: "Contractor",
            link: routes.contractors,
            requiredPermission: "transport.view",
            visible: true,
          },
          {
            label: "Shift",
            link: routes.transportShift,
            requiredPermission: "transport.view",
            visible: true,
          },
          {
            label: "Vehicle",
            link: routes.transportVehicle,
            requiredPermission: "transport.view",
            visible: true,
          },
          {
            label: "Driver",
            link: routes.transportVehicleDrivers,
            requiredPermission: "transport.view",
            visible: true,
          },
          {
            label: "Contractor Payout",
            link: routes.transportContractorPayout,
            requiredPermission: "transport.view",
            visible: true,
          },
        ],
      },
      {
        label: "School Opening",
        icon: "ti ti-lock-open",
        link: routes.schoolOpening,
        showSubRoute: false,
        submenu: false,
        requiredPermission: "school-opening.view",
        visible: true,
      },
    ],
  },
  {
    label: "FEES COLLECTION",
    submenuOpen: true,
    submenuHdr: "Fees Collection",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Tuition Fee",
        link: routes.collectFees,
        icon: "ti ti-report-money",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "fees.view",
        visible: true,
      },
      {
        label: "Transportation Fee",
        link: routes.transportInvoices,
        icon: "ti ti-bus",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "fees.view",
        visible: true,
      },
    ],
  },
  {
    label: "RMS",
    submenuOpen: true,
    submenuHdr: "RMS",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Roster",
        icon: "ti ti-users",
        submenu: true,
        showSubRoute: false,
        // Admin/staff only -- RMS itself gives a teacher a completely
        // separate, minimal nav (Dashboard / Mark Entry / Final Term
        // Carryover only). Without this, a teacher's zero RBAC permission
        // rows would fail the sidebar open (see filterSidebarByPermissions)
        // and show every admin menu anyway.
        hideForTeacher: true,
        submenuItems: [
          // Students List lives under People — removed from RMS Roster.
          // { label: "Students",     link: routes.studentList,         showSubRoute: false },
          // Roll Numbers -- removed, was a dead duplicate (link: "#") of the
          // real, working entry under RMS -> Operations.
          { label: "Teachers",     link: routes.teacherList,        showSubRoute: false, requiredPermission: "teachers.view", visible: true },
        ],
      },
      {
        label: "Teacher Portal",
        icon: "ti ti-chalkboard",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          { label: "Teacher Dashboard", link: routes.teacherDashboard, showSubRoute: false, visible: true },
          // Points at the same role-aware page as Operations -> Marks Entry
          // below (routes.marks shows the self-service view for a teacher) --
          // listed here too since Operations itself is hidden for teacher,
          // matching RMS's own minimal teacher nav (Dashboard / Mark Entry /
          // Final Term Carryover, nothing else).
          { label: "Mark Entry", link: routes.marks, showSubRoute: false, visible: true },
          // FY1 (Eon) only -- hidden from a teacher unless they're the
          // class teacher of an FY1 section (see requiresFy1Assignment in
          // filterSidebarByPermissions). Still visible to non-teacher roles.
          { label: "FY1 Checklist", link: routes.rubricChecklist, showSubRoute: false, visible: true, requiresFy1Assignment: true },
          { label: "Final Term Carryover", link: routes.teacherFinalTerm, showSubRoute: false, visible: true },
        ],
      },
      {
        label: "Operations",
        icon: "ti ti-adjustments-horizontal",
        submenu: true,
        showSubRoute: false,
        // Admin/staff only -- RMS gives a teacher just the Teacher Portal
        // items above, nothing from this admin-wide operations menu.
        hideForTeacher: true,
        // RMS pages are permission-gated so roles without them (e.g. cashier)
        // don't see the menu (the API already 403s them). Permission names match
        // the backend checkPermission modules exactly.
        submenuItems: [
          { label: "Result Breakdowns",    link: routes.resultBreakdown,    showSubRoute: false, requiredPermission: "resultBreakdown.view", visible: true },
          { label: "Course Structures",    link: routes.courseStructures,   showSubRoute: false, requiredPermission: "course-structure.view", visible: true },
          { label: "Marks Allocation",     link: routes.marksAllocation,     showSubRoute: false, requiredPermission: "course-structure.view", visible: true },
          { label: "Marks Entry",          link: routes.marks,              showSubRoute: false, requiredPermission: "student-marks.view", teacherAllowed: true, visible: true },
          { label: "Marks Tabulation",     link: routes.marksTabulation,    showSubRoute: false, requiredPermission: "student-marks.view", visible: true },
          { label: "Roll Numbers",         link: routes.rollNumber,         showSubRoute: false, requiredPermission: "rollNumber.view", visible: true },
          { label: "Report Cards",         link: routes.reportCard,         showSubRoute: false, requiredPermission: "resultBreakdown.view", visible: true },
          { label: "Report Card Designer", link: routes.reportCardDesigner, showSubRoute: false, requiredPermission: "resultBreakdown.view", visible: true },
          { label: "Final Term Carryover", link: routes.finalTermEntry,     showSubRoute: false, requiredPermission: "student-marks.view", visible: true },
          // Admin/owner-only (they carry empty permissions → fail-open). Any role
          // WITH permissions but without "approvals.view" is filtered out here, so
          // non-admins never see it. Backend also role-gates admin/owner.
          { label: "Approvals",            link: routes.approvals,          showSubRoute: false, requiredPermission: "approvals.view", visible: true },
          { label: "Reports",              link: routes.reports,            showSubRoute: false, requiredPermission: "reports.view", visible: true },
        ],
      },
      {
        label: "Certificates",
        icon: "ti ti-certificate",
        submenu: true,
        showSubRoute: false,
        hideForTeacher: true,
        submenuItems: [
          { label: "Overview",         link: routes.certOverview,        showSubRoute: false, requiredPermission: "certificate.view", visible: true },
          { label: "Generate",         link: routes.certGenerate,        showSubRoute: false, requiredPermission: "certificate.view", visible: true },
          { label: "Records",          link: routes.certRecords,         showSubRoute: false, requiredPermission: "certificate.view", visible: true },
          { label: "Templates",        link: routes.certTemplates,       showSubRoute: false, requiredPermission: "certificate.view", visible: true },
          { label: "Master Templates", link: routes.certMasterTemplates, showSubRoute: false, requiredPermission: "certificate.view", visible: true },
          { label: "Settings",         link: routes.certSettings,        showSubRoute: false, requiredPermission: "certificate.view", visible: true },
        ],
      },
      {
        label: "Configuration",
        icon: "ti ti-settings-2",
        submenu: true,
        showSubRoute: false,
        hideForTeacher: true,
        submenuItems: [
          { label: "Board Systems",            link: routes.boardSystems, showSubRoute: false, requiredPermission: "grade_configs.view", visible: true },
          // Campus Management is super-admin gated -- superAdminOnly bypasses
          // the grade_configs.view check below so a non-super-admin with that
          // permission doesn't get a link that just dead-ends on a 403/redirect.
          { label: "Campuses",                 link: routes.branchManagement, showSubRoute: false, superAdminOnly: true, visible: true },
          { label: "Class Groups",             link: routes.academicGroups, showSubRoute: false, requiredPermission: "grade_configs.view", visible: true },
          // Classes and Sections moved to the Settings group.
          // { label: "Classes / Grades",         link: "#",                showSubRoute: false },
          // { label: "Sections",                 link: "#",                showSubRoute: false },
          // "Subjects" dropped -- pure duplicate of Courses below (RMS
          // "subjects" == our Course model), both already in this same menu.
          // Courses moved here from the Academic section (basic course/subject
          // catalog -- distinct from Course Structures under Operations, which
          // builds on top of it).
          { label: "Courses",                  link: routes.courses,    showSubRoute: false, requiredPermission: "courses.view", visible: true },
          // Sessions moved to the Settings group.
          // { label: "Sessions",                 link: routes.Session,     showSubRoute: false },
          { label: "Grade Scales",             link: routes.gradeConfig, showSubRoute: false, requiredPermission: "grade_configs.view", visible: true },
          { label: "Bell-Curve Thresholds",    link: "#",                showSubRoute: false, requiredPermission: "grade_configs.view", visible: true },
          { label: "Grade Blurbs",             link: routes.gradeBlurbs, showSubRoute: false, requiredPermission: "resultBreakdown.view", visible: true },
          { label: "Provisional Grade Scales", link: routes.provisionalGradeScales, showSubRoute: false, requiredPermission: "grade_configs.view", visible: true },
          // Exam Terms -- moved here from the Academic section (was "Term").
          // Keeps its own actual permission (term.view), not grade_configs.view.
          { label: "Exam Terms",               link: routes.term,       showSubRoute: false, requiredPermission: "term.view", visible: true },
        ],
      },
    ],
  },
  // {
  //   label: "HRM",
  //   submenuOpen: true,
  //   submenuHdr: "HRM",
  //   submenu: false,
  //   showSubRoute: false,
  //   submenuItems: [
  //     {
  //       label: "Staffs",
  //       link: routes.staff,
  //       subLink1: routes.addStaff,
  //       subLink2: routes.editStaff,
  //       icon: "ti ti-users-group",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Departments",
  //       link: routes.departments,
  //       icon: "ti ti-layout-distribute-horizontal",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Designation",
  //       link: routes.designation,
  //       icon: "ti ti-user-exclamation",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  {
    label: "Attendance",
    icon: "ti ti-calendar-share",
    submenu: true,
    showSubRoute: false,
    visible: true,
    submenuItems: [
      {
        label: "Student Attendance",
        link: routes.studentAttendance,
        requiredPermission: "student-attendance.view",
        icon: "ti ti-users",
        visible: true,
      },
      {
        label: "Staff Attendance",
        link: routes.staffAttendance,
        requiredPermission: "employee-attendance.view",
        icon: "ti ti-users-group",
        visible: true,
      },
      {
        label: "Blank Attendance Sheet",
        link: routes.blankAttendanceSheet,
        requiredPermission: "attendance-report.view",
        icon: "ti ti-file-spreadsheet",
        visible: true,
      },
      {
        label: "Leaves",
        link: routes.listLeaves,
        requiredPermission: "leaves.view",
        icon: "ti ti-calendar-stats",
        visible: true,
      },
      {
        label: "Student Suspensions",
        link: routes.studentSuspensions,
        requiredPermission: "student-attendance.view",
        icon: "ti ti-user-pause",
        visible: true,
      },
      {
        label: "Transfer Certificate",
        link: routes.transferCertificate,
        requiredPermission: "transfer-certificate.view",
        icon: "ti ti-certificate",
        visible: true,
      },
    ],
  },
  //     {
  //       label: "Holidays",
  //       link: routes.holidays,
  //       icon: "ti ti-briefcase",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Payroll",
  //       link: routes.payroll,
  //       icon: "ti ti-moneybag",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //   ],
  // },
  {
    label: "Finance & Accounts",
    submenuOpen: true,
    submenuHdr: "Finance & Accounts",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      // { label: "Expenses", link: routes.expense },
      // { label: "Expense Category", link: routes.expenseCategory },
      // { label: "Income", link: routes.accountsIncome },
      {
        label: "Invoices",
        link: routes.accountsInvoices,
        subLink1: routes.addInvoice,
        subLink2: routes.editInvoice,
        icon: "ti ti-swipe",
        requiredPermission: "invoices.view",
        visible: true,
      },
      // { label: "Invoice View", link: routes.invoice },
      // { label: "Transactions", link: routes.accountsTransactions },
    ],
  },
  // {
  //   label: "Announcements",
  //   submenuOpen: true,
  //   submenuHdr: "Announcements",
  //   submenu: false,
  //   showSubRoute: false,
  //   submenuItems: [
  //     {
  //       label: "Notice Board",
  //       link: routes.noticeBoard,
  //       icon: "ti ti-clipboard-data",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     // {
  //     //   label: "Events",
  //     //   link: routes.events,
  //     //   icon: "ti ti-calendar-question",
  //     //   showSubRoute: false,
  //     //   submenu: false,
  //     // },
  //   ],
  // },
  {
    label: "Reports",
    submenuOpen: true,
    submenuHdr: "Reports",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Attendance Report",
        link: routes.attendanceReport,
        // subLink1: routes.studentAttendanceType,
        subLink2: routes.staffReport,
        // subLink3: routes.teacherReport,
        // subLink4: routes.staffDayWise,
        // subLink5: routes.teacherDayWise,
        // subLink6: routes.studentDayWise,
        // subLink7: routes.dailyAttendance,
        icon: "ti ti-calendar-due",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "attendance-report.view",
        visible: true,
      },
      {
        label: "Own Attendance",
        link: routes.ownAttendance,
        icon: "ti ti-user",
        requiredPermission: "own-attendance.view",
        // requiredPermission: "attendance-report.own",
        visible: true,
      },
      // {
      //   label: "Class Report",
      //   link: routes.classReport,
      //   icon: "ti ti-graph",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      // {
      //   label: "Student Report",
      //   link: routes.studentReport,
      //   icon: "ti ti-chart-infographic",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      // {
      //   label: "Grade Report",
      //   link: routes.gradeReport,
      //   icon: "ti ti-calendar-x",
      //   showSubRoute: false,
      //   submenu: false,
      // },
      // {
      //   label: "Leave Report",
      //   link: routes.leaveReport,
      //   icon: "ti ti-line",
      //   showSubRoute: false,
      //   submenu: false,
      // },
 
    ],
  },
  {
    label: "USER MANAGEMENT",
    submenuOpen: true,
    submenuHdr: "Sales",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Users",
        link: routes.manageusers,
        icon: "ti ti-users-minus",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "user.view",
        visible: true,
      },
      {
        label: "Roles & Permission",
        link: routes.rolesPermissions,
        icon: "ti ti-shield-plus",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "role.view",
        visible: true,
      },
      {
        label: "Campus Management",
        link: routes.branchManagement,
        icon: "ti ti-building-community",
        showSubRoute: false,
        submenu: false,
        // Super-admin (owner/admin) only — hidden from every other role.
        superAdminOnly: true,
        visible: true,
      },
      {
        label: "Activity Log",
        link: routes.activityLog,
        icon: "ti ti-history",
        showSubRoute: false,
        submenu: false,
        // Owner only — who did what, when. Hidden from every other role,
        // admins included.
        ownerOnly: true,
        visible: true,
      },
      // {
      //   label: "Delete Account Request",
      //   link: routes.deleteRequest,
      //   icon: "ti ti-user-question",
      //   showSubRoute: false,
      //   submenu: false,
      // },
    ],
  },
  // {
  //   label: "MEMBERSHIP",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Finance & Accounts",
  //   submenuItems: [
  //     {
  //       label: "Membership Plans",
  //       link: routes.membershipplan,
  //       icon: "ti ti-user-plus",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Membership Addons",
  //       link: routes.membershipAddon,
  //       icon: "ti ti-cone-plus",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Transactions",
  //       link: routes.membershipTransaction,
  //       icon: "ti ti-file-power",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //   ],
  // },
  // {
  //   label: "CONTENT",
  //   icon: "ti ti-page-break",
  //   submenu: true,
  //   showSubRoute: false,
  //   submenuItems: [
  //     {
  //       label: "Pages",
  //       link: routes.pages,
  //       showSubRoute: false,
  //       icon: "ti ti-page-break",
  //     },
  //     {
  //       label: "Blog",
  //       icon: "ti ti-brand-blogger",
  //       submenu: true,
  //       submenuItems: [
  //         { label: "All Blogs", link: routes.allBlogs },
  //         {
  //           label: "Categories",
  //           link: routes.blogCategories,
  //           icon: "ti ti-quote",
  //         },
  //         {
  //           label: "Comments",
  //           link: routes.blogComments,
  //           icon: "ti ti-question-mark",
  //         },
  //         {
  //           label: "Tags",
  //           link: routes.blogTags,
  //           icon: "ti ti-question-mark",
  //         },
  //       ],
  //     },
  //     {
  //       label: "Location",
  //       icon: "ti ti-map-pin-search",
  //       submenu: true,
  //       submenuItems: [
  //         { label: "Countries", link: routes.countries },
  //         { label: "States", link: routes.states, icon: "ti ti-quote" },
  //         {
  //           label: "Cities",
  //           link: routes.cities,
  //           icon: "ti ti-question-mark",
  //         },
  //       ],
  //     },
  //     {
  //       label: "Testimonials",
  //       link: routes.testimonials,
  //       showSubRoute: false,
  //       icon: "ti ti-quote",
  //     },
  //     {
  //       label: "FAQ",
  //       link: routes.faq,
  //       showSubRoute: false,
  //       icon: "ti ti-question-mark",
  //     },
  //   ],
  // },
  // {
  //   label: "Support",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Finance & Accounts",
  //   submenuItems: [
  //     {
  //       label: "Contact Messages",
  //       link: routes.contactMessages,
  //       icon: "ti ti-message",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Tickets",
  //       link: routes.tickets,
  //       icon: "ti ti-ticket",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //   ],
  // },
  // {
  //   label: "Pages",
  //   submenu: true,
  //   showSubRoute: false,
  //   submenuHdr: "Authentication",
  //   submenuItems: [
  //     {
  //       label: "Profile",
  //       link: routes.profile,
  //       icon: "ti ti-user",
  //       showSubRoute: false,
  //       submenu: false,
  //     },

  //     {
  //       label: "Authentication",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-lock-square-rounded",
  //       submenuItems: [
  //         {
  //           label: "Login",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Cover", link: routes.login },
  //             { label: "Illustration", link: routes.login },
  //             { label: "Basic", link: routes.login },
  //           ],
  //         },
  //         {
  //           label: "Register",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Cover", link: routes.register },
  //             { label: "Illustration", link: routes.register },
  //             { label: "Basic", link: routes.register },
  //           ],
  //         },
  //         {
  //           label: "Forgot Password",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Cover", link: routes.forgotPassword },
  //             { label: "Illustration", link: routes.forgotPassword },
  //             { label: "Basic", link: routes.forgotPassword },
  //           ],
  //         },
  //         {
  //           label: "Reset Password",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Cover", link: routes.resetPassword },
  //             { label: "Illustration", link: routes.resetPassword },
  //             { label: "Basic", link: routes.resetPassword },
  //           ],
  //         },
  //         {
  //           label: "Email Verfication",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Cover", link: routes.emailVerification },
  //             { label: "Illustration", link: routes.emailVerification },
  //             { label: "Basic", link: routes.emailVerification },
  //           ],
  //         },
  //         {
  //           label: "2 Step Verification",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Cover", link: routes.emailVerification },
  //             { label: "Illustration", link: routes.emailVerification },
  //             { label: "Basic", link: routes.emailVerification },
  //           ],
  //         },
  //         { label: "Lock Screen", link: routes.lockScreen },
  //       ],
  //     },
  //     {
  //       label: "Error Pages",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-error-404",
  //       submenuItems: [
  //         {
  //           label: "404 Error",
  //           link: routes.error404,
  //           showSubRoute: false,
  //         },
  //         { label: "500 Error", link: routes.error500, showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Blank Page",
  //       link: routes.blankPage,
  //       icon: "ti ti-brand-nuxt",
  //       showSubRoute: false,
  //       submenu: false,
  //     },
  //     {
  //       label: "Coming Soon",
  //       link: routes.comingSoon,
  //       icon: "ti ti-file",
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Under Maintenance",
  //       link: routes.underMaintenance,
  //       icon: "ti ti-moon-2",
  //       showSubRoute: false,
  //     },
  //   ],
  // },
  {
    label: "Settings",
    submenu: true,
    showSubRoute: false,
    submenuHdr: "Settings",
    submenuItems: [
      // Moved here from Academic / System Settings — kept their existing routes.
      {
        label: "Classes",
        icon: "ti ti-school-bell",
        link: routes.classes,
        showSubRoute: false,
        requiredPermission: "class.view",
        visible: true,
      },
      {
        label: "Sections",
        icon: "ti ti-square-rotated-forbid-2",
        link: routes.classSection,
        showSubRoute: false,
        // Had no requiredPermission at all -- the "no permission required"
        // fallback kept it visible for every role unconditionally, including
        // teacher (who should see nothing from Settings). Mirrors its sibling
        // "Classes" above, which shares the same admin-settings scope.
        requiredPermission: "class.view",
        visible: true,
      },
      {
        label: "Session",
        icon: "ti ti-calendar",
        link: routes.Session,
        showSubRoute: false,
        requiredPermission: "session.view",
        visible: true,
      },
      {
        label: "Fee Sticker Designer",
        icon: "ti ti-sticker",
        link: routes.feeStickerDesigner,
        showSubRoute: false,
        requiredPermission: "certificate.view",
        visible: true,
      },
      {
        label: "Shift Timings",
        icon: "ti ti-clock-hour-4",
        link: routes.Shifts,
        showSubRoute: false,
        requiredPermission: "shift.view",
        visible: true,
      },
      // {
      //   label: "General Settings",
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: "ti ti-shield-cog",
      //   submenuItems: [
      //     { label: "Profile Settings", link: routes.profilesettings },
      //     { label: "Security Settings", link: routes.securitysettings },
      //     {
      //       label: "Notifications Settings",
      //       link: routes.notificationssettings,
      //     },
      //     { label: "Connected Apps", link: routes.connectedApps },
      //   ],
      // },
      // {
      //   label: "Website Settings",
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: "ti ti-device-laptop",
      //   submenuItems: [
      //     {
      //       label: "Company Settings",
      //       link: routes.companySettings,
      //       showSubRoute: false,
      //     },
      //     {
      //       label: "Localization",
      //       link: routes.localization,
      //       showSubRoute: false,
      //     },
      //     { label: "Prefixes", link: routes.prefixes, showSubRoute: false },
      //     { label: "Preference", link: routes.preference, showSubRoute: false },
      //     {
      //       label: "Social Authentication",
      //       link: routes.socialAuthentication,
      //       showSubRoute: false,
      //     },
      //     {
      //       label: "Language",
      //       link: routes.language,
      //       showSubRoute: false,
      //     },
      //   ],
      // },
      // {
      //   label: "App Settings",
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: "ti ti-apps",
      //   submenuItems: [
      //     {
      //       label: "Invoice Settings",
      //       link: routes.invoiceSettings,
      //       showSubRoute: false,
      //     },
      //     {
      //       label: "Custom Fields",
      //       link: routes.customFields,
      //       showSubRoute: false,
      //     },
      //   ],
      // },
      {
        label: "System Settings",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-file-symlink",
        submenuItems: [
          // {
          //   label: "Email Settings",
          //   link: routes.emailSettings,
          //   showSubRoute: false,
          //   visible: true,
          // },
          {
            label: "Email Templates",
            link: routes.emailTemplatesList,
            showSubRoute: false,
            requiredPermission: "email.view",
            visible: true,
          },
          // Fee Sticker Designer moved up to sit directly under Settings.
          // {
          //   label: "SMS Settings",
          //   link: routes.smsSettings,
          //   showSubRoute: false,
          // },
          // {
          //   label: "OTP",
          //   link: routes.optSettings,
          //   showSubRoute: false,
          // },
          // {
          //   label: "GDPR Cookies",
          //   link: routes.gdprCookies,
          //   showSubRoute: false,
          // },
        ],
      },
      // {
      //   label: "Financial Settings",
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: "ti ti-zoom-money",
      //   submenuItems: [
      //     {
      //       label: "Payment Gateway",
      //       link: routes.paymentGateways,
      //       showSubRoute: false,
      //     },
      //     { label: "Tax Rates", link: routes.taxRates, showSubRoute: false },
      //   ],
      // },
      // {
      //   label: "Academic Settings",
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: "ti ti-calendar-repeat",
      //   submenuItems: [
      //     {
      //       label: "School Settings",
      //       link: routes.schoolSettings,
      //       showSubRoute: false,
      //     },
      //     { label: "Religion", link: routes.religion, showSubRoute: false },
      //   ],
      // },
      // {
      //   label: "Other Settings",
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: "ti ti-flag-cog",
      //   submenuItems: [
      //     { label: "Storage", link: routes.storage, showSubRoute: false },
      //     {
      //       label: "Ban IP Address",
      //       link: routes.banIpAddress,
      //       showSubRoute: false,
      //     },
      //   ],
      // },
    ],
  },
  // {
  //   label: "UI Interface",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "UI Interface",
  //   submenuItems: [
  //     {
  //       label: "Base UI",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-hierarchy-2",
  //       submenuItems: [
  //         { label: "Alerts", link: routes.alert, showSubRoute: false },
  //         { label: "Accordion", link: routes.accordion, showSubRoute: false },
  //         { label: "Avatar", link: routes.avatar, showSubRoute: false },
  //         { label: "Badges", link: routes.uiBadges, showSubRoute: false },
  //         { label: "Border", link: routes.border, showSubRoute: false },
  //         { label: "Buttons", link: routes.button, showSubRoute: false },
  //         {
  //           label: "Button Group",
  //           link: routes.buttonGroup,
  //           showSubRoute: false,
  //         },
  //         { label: "Breadcrumb", link: routes.breadcrums, showSubRoute: false },
  //         { label: "Card", link: routes.cards, showSubRoute: false },
  //         { label: "Carousel", link: routes.carousel, showSubRoute: false },
  //         { label: "Colors", link: routes.colors, showSubRoute: false },
  //         { label: "Dropdowns", link: routes.dropdowns, showSubRoute: false },
  //         { label: "Grid", link: routes.grid, showSubRoute: false },
  //         { label: "Images", link: routes.images, showSubRoute: false },
  //         { label: "Lightbox", link: routes.lightbox, showSubRoute: false },
  //         { label: "Media", link: routes.media, showSubRoute: false },
  //         { label: "Modals", link: routes.modals, showSubRoute: false },
  //         { label: "Offcanvas", link: routes.offcanvas, showSubRoute: false },
  //         { label: "Pagination", link: routes.pagination, showSubRoute: false },
  //         { label: "Popovers", link: routes.popover, showSubRoute: false },
  //         { label: "Progress", link: routes.progress, showSubRoute: false },
  //         {
  //           label: "Placeholders",
  //           link: routes.placeholder,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Range Slider",
  //           link: routes.rangeSlider,
  //           showSubRoute: false,
  //         },
  //         { label: "Spinner", link: routes.spinner, showSubRoute: false },
  //         {
  //           label: "Sweet Alerts",
  //           link: routes.sweetalert,
  //           showSubRoute: false,
  //         },
  //         { label: "Tabs", link: routes.navTabs, showSubRoute: false },
  //         { label: "Toasts", link: routes.toasts, showSubRoute: false },
  //         { label: "Tooltips", link: routes.tooltip, showSubRoute: false },
  //         { label: "Typography", link: routes.typography, showSubRoute: false },
  //         { label: "Video", link: routes.video, showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Advanced UI",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-hierarchy-3",
  //       submenuItems: [
  //         { label: "Ribbon", link: routes.ribbon, showSubRoute: false },
  //         { label: "Clipboard", link: routes.clipboard, showSubRoute: false },
  //         {
  //           label: "Drag & Drop",
  //           link: routes.dragandDrop,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Range Slider",
  //           link: routes.rangeSlider,
  //           showSubRoute: false,
  //         },
  //         { label: "Rating", link: routes.rating, showSubRoute: false },
  //         {
  //           label: "Text Editor",
  //           link: routes.textEditor,
  //           showSubRoute: false,
  //         },
  //         { label: "Counter", link: routes.counter, showSubRoute: false },
  //         { label: "Scrollbar", link: routes.scrollBar, showSubRoute: false },
  //         {
  //           label: "Sticky Note",
  //           link: routes.stickyNotes,
  //           showSubRoute: false,
  //         },
  //         { label: "Timeline", link: routes.timeLine, showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Charts",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-chart-line",
  //       submenuItems: [
  //         { label: "Apex Charts", link: routes.apexChat, showSubRoute: false },
  //         // { label: "Chart Js", link: routes.chart, showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Icons",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-icons",
  //       submenuItems: [
  //         {
  //           label: "Fontawesome Icons",
  //           link: routes.fantawesome,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Feather Icons",
  //           link: routes.featherIcons,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Ionic Icons",
  //           link: routes.iconicIcon,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Material Icons",
  //           link: routes.materialIcon,
  //           showSubRoute: false,
  //         },
  //         { label: "Pe7 Icons", link: routes.pe7icon, showSubRoute: false },
  //         {
  //           label: "Simpleline Icons",
  //           link: routes.simpleLineIcon,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Themify Icons",
  //           link: routes.themifyIcon,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Weather Icons",
  //           link: routes.weatherIcon,
  //           showSubRoute: false,
  //         },
  //         {
  //           label: "Typicon Icons",
  //           link: routes.typicon,
  //           showSubRoute: false,
  //         },
  //         { label: "Flag Icons", link: routes.falgIcons, showSubRoute: false },
  //       ],
  //     },
  //     {
  //       label: "Forms",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-input-search",
  //       submenuItems: [
  //         {
  //           label: "Form Elements",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {
  //               label: "Basic Inputs",
  //               link: routes.basicInput,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Checkbox & Radios",
  //               link: routes.checkboxandRadion,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Input Groups",
  //               link: routes.inputGroup,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Grid & Gutters",
  //               link: routes.gridandGutters,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Form Select",
  //               link: routes.formSelect,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "Input Masks",
  //               link: routes.formMask,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: "File Uploads",
  //               link: routes.fileUpload,
  //               showSubRoute: false,
  //             },
  //           ],
  //         },
  //         {
  //           label: "Layouts",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Horizontal Form", link: routes.horizontalForm },
  //             { label: "Vertical Form", link: routes.verticalForm },
  //             { label: "Floating Labels", link: routes.floatingLable },
  //           ],
  //         },
  //         { label: "Form Validation", link: routes.formValidation },
  //         { label: "Select", link: routes.reactSelect },
  //         // { label: "Form Wizard", link: routes.formWizard },
  //       ],
  //     },
  //     {
  //       label: "Tables",
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: "ti ti-table-plus",
  //       submenuItems: [
  //         { label: "Basic Tables", link: "/tables-basic" },
  //         { label: "Data Table", link: "/data-tables" },
  //       ],
  //     },
  //   ],
  // },
  /* 
  @TODO: Uncomment this section if you want to add a Help section in the sidebar
  */
  // {
  //   label: "Help",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Help",
  //   submenuItems: [
  //     {
  //       label: "Documentation",
  //       link: "https://preschool.dreamstechnologies.com/documentation/index.html",
  //       icon: "ti ti-file-text",
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Changelog ",
  //       version: "v1.8.3",
  //       link: "https://preschool.dreamstechnologies.com/documentation/changelog.html",
  //       icon: "ti ti-exchange",
  //       showSubRoute: false,
  //     },
  //     {
  //       label: "Multi Level",
  //       showSubRoute: false,
  //       submenu: true,
  //       icon: "ti ti-menu-2",
  //       submenuItems: [
  //         { label: "Level 1.1", link: "#", showSubRoute: false },
  //         {
  //           label: "Level 1.2",
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             { label: "Level 2.1", link: "#", showSubRoute: false },
  //             {
  //               label: "Level 2.2",
  //               submenu: true,
  //               showSubRoute: false,
  //               submenuItems: [
  //                 { label: "Level 3.1", link: "#", showSubRoute: false },
  //                 { label: "Level 3.2", link: "#", showSubRoute: false },
  //               ],
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },
]

const menuIcons: Record<string, string> = {
  Dashboard: "ti ti-layout-dashboard",
  People: "ti ti-users",
  Attendance: "ti ti-calendar-share",
  "Fees Collection": "ti ti-report-money",
  Admissions: "ti ti-clipboard-text",
  Academic: "ti ti-book",
  Library: "ti ti-notebook",
  Management: "ti ti-briefcase",
  RMS: "ti ti-report-analytics",
  Accounts: "ti ti-wallet",
  Reports: "ti ti-chart-bar",
  Transport: "ti ti-bus",
  "User Management": "ti ti-user-cog",
  Settings: "ti ti-settings",
}

const menuLabelOverrides: Record<string, string> = {
  MAIN: "Dashboard",
  MANAGEMENT: "Management",
  "FEES COLLECTION": "Fees Collection",
  "Finance & Accounts": "Accounts",
  "USER MANAGEMENT": "User Management",
}

const menuOrder = [
  "Dashboard",
  "People",
  "Attendance",
  "Fees Collection",
  "Reports",
  "Admissions",
  "Academic",
  "RMS",
  "Accounts",
  "User Management",
  "Library",
  "Transport",
  "Management",
  "Settings",
]

const getMenuLabel = (section: any) =>
  menuLabelOverrides[section.label] || section.label

const cloneMenuItem = (item: any) => ({
  ...item,
  submenuItems: item.submenuItems?.map(cloneMenuItem),
})

const dashboardItem = (section: any) => {
  const dashboard = section.submenuItems?.find(
    (item: any) => item.label === "Dashboard"
  )

  return dashboard
    ? { ...cloneMenuItem(dashboard), label: "Dashboard" }
    : {
        label: "Dashboard",
        link: routes.adminDashboard,
        icon: menuIcons.Dashboard,
        showSubRoute: false,
        submenu: false,
        requiredPermission: "dashboard.view",
        visible: true,
      }
}

const studentPromotionItem = baseSidebarData
  .flatMap((section: any) => section.submenuItems || [])
  .flatMap((item: any) => item.submenuItems || [])
  .find((item: any) => item.label === "Student Promotion")

const emailTemplatesItem = baseSidebarData
  .flatMap((section: any) => section.submenuItems || [])
  .flatMap((item: any) => item.submenuItems || [])
  .find((item: any) => item.label === "Email Templates")

const feeTypesItem = baseSidebarData
  .flatMap((section: any) => section.submenuItems || [])
  .flatMap((item: any) => item.submenuItems || [])
  .find((item: any) => item.label === "Fees")

const defaultersListItem = baseSidebarData
  .flatMap((section: any) => section.submenuItems || [])
  .flatMap((item: any) => item.submenuItems || [])
  .find((item: any) => item.label === "Defaulters List")

const campusManagementItem = baseSidebarData
  .flatMap((section: any) => section.submenuItems || [])
  .find((item: any) => item.label === "Campus Management")

const promotedMenuLabels = ["Library", "Transport"]

const promotedMenuItem = (label: string) =>
  baseSidebarData
    .flatMap((section: any) => section.submenuItems || [])
    .find((item: any) => item.label === label)

const normalizeSection = (section: any) => {
  const label = getMenuLabel(section)

  if (label === "Dashboard") {
    return dashboardItem(section)
  }

  let submenuItems = section.submenuItems?.map(cloneMenuItem) || []

  if (label === "People") {
    const students = submenuItems.find((item: any) => item.label === "Students")

    // Teachers moved to RMS -> Roster (2026-09-03) -- no longer duplicated
    // here under People.
    //
    // This rebuild discards whatever the section declared, so anything that
    // belongs under People has to be listed here as well as in the source
    // data — declaring it there alone silently drops it, which is how
    // Transfer Certificate went missing from both the menu and its search.
    submenuItems = [
      students && {
        ...students,
        link: routes.studentList,
        submenu: false,
        showSubRoute: false,
        requiredPermission: "student.view",
        visible: true,
        submenuItems: undefined,
      },
      {
        label: "Student Status",
        link: routes.studentStatus,
        submenu: false,
        showSubRoute: false,
        requiredPermission: "student-status.view",
        visible: true,
      },
    ].filter(Boolean)
  }

  if (label === "Accounts") {
    if (
      defaultersListItem &&
      !submenuItems.some((item: any) => item.label === "Defaulters List")
    ) {
      submenuItems.push({
        ...cloneMenuItem(defaultersListItem),
        icon: "ti ti-file-invoice",
      })
    }
  }

  if (label === "Management") {
    submenuItems = submenuItems.filter(
      (item: any) =>
        item.label !== "Fees Collection" &&
        item.label !== "Defaulters" &&
        !promotedMenuLabels.includes(item.label)
    )
  }

  if (label === "User Management") {
    submenuItems = submenuItems.filter(
      (item: any) => item.label !== "Campus Management"
    )
  }

  if (label === "Reports") {
    submenuItems = [
      ...submenuItems,
      {
        label: "Cashier Report",
        link: routes.cashierReport,
        icon: "ti ti-report-money",
        showSubRoute: false,
        submenu: false,
        requiredPermission: "invoices.view",
        visible: true,
      },
    ]
  }

  if (label === "Settings") {
    // Drop the old "System Settings" wrapper — its one live child (Email
    // Templates) now lives directly under the Templates group below.
    // Rename Fee Sticker Designer -> Sticker Template here too.
    const academicYearItems = submenuItems
      .filter((item: any) => item.label !== "System Settings")
      .map((item: any) =>
        item.label === "Fee Sticker Designer"
          ? { ...item, label: "Sticker Template" }
          : item
      )

    if (
      studentPromotionItem &&
      !academicYearItems.some(
        (item: any) => item.label === "Student Promotion"
      )
    ) {
      academicYearItems.push({
        ...cloneMenuItem(studentPromotionItem),
        icon: "ti ti-user-up",
      })
    }

    if (
      feeTypesItem &&
      !academicYearItems.some((item: any) => item.label === "Fee Types")
    ) {
      academicYearItems.push({
        ...cloneMenuItem(feeTypesItem),
        label: "Fee Types",
        icon: "ti ti-receipt-tax",
      })
    }

    academicYearItems.push({
      label: "Fee Sticker Printing",
      link: routes.feeStickerPrint,
      icon: "ti ti-ticket",
      requiredPermission: "fees.view",
      visible: true,
    })

    // Sticker Template belongs in Templates, not Academic Year.
    const feeStickerTemplateItem = academicYearItems.find(
      (item: any) => item.label === "Sticker Template"
    )
    const academicYearFinal = academicYearItems.filter(
      (item: any) => item.label !== "Sticker Template"
    )

    const templatesItems = [
      feeStickerTemplateItem,
      emailTemplatesItem && {
        ...cloneMenuItem(emailTemplatesItem),
        icon: "ti ti-mail",
      },
    ].filter(Boolean)

    const adminSettingsItems = [
      campusManagementItem && cloneMenuItem(campusManagementItem),
    ].filter(Boolean)

    submenuItems = [
      {
        label: "Academic Year",
        icon: "ti ti-calendar-event",
        submenu: true,
        showSubRoute: false,
        submenuItems: academicYearFinal,
      },
      {
        label: "Templates",
        icon: "ti ti-template",
        submenu: true,
        showSubRoute: false,
        submenuItems: templatesItems,
      },
      {
        label: "Admin Settings",
        icon: "ti ti-settings-cog",
        submenu: true,
        showSubRoute: false,
        submenuItems: adminSettingsItems,
      },
    ]
  }

  return {
    ...section,
    label,
    icon: section.icon || menuIcons[label] || "ti ti-circle",
    submenu: true,
    showSubRoute: false,
    submenuItems,
  }
}

export const SidebarData = menuOrder
  .map((label) => {
    const section = baseSidebarData.find(
      (item: any) => getMenuLabel(item) === label
    )

    return section || promotedMenuItem(label)
  })
  .filter(Boolean)
  .map(normalizeSection)
